module.exports = __webpack_public_path__ + "static/media/largeOutlinedShield.7ea23512.svg";